<div class="datiq-graph">
    <div #graphContainer [id]="id" class="datiq-graph__container"></div>
</div>
